import addDomainButton from './addDomainButton'
import domainCard from './domainCard'

export default {
  title: 'Definir domínio',
  description: `Um domínio é um endereço de um site (ex: www.nomedaempresa.com.br).
                Você pode adicionar um domínio que tenha comprado, definir um domínio
                temporário como principal, incluir domínios alternativos que apontem para o
                mesmo site, alterar ou excluir domínios.`,
  addDomainButton,
  domainCard
}
